
<template>
    <div class="check-main-wrapper">
        <v-checkbox
            :error="error"
            :key="value"
            :class="`check-box check-box__${value ? 'activate' : 'deactivate'}`"
            @change="change"
            :input-value="value" 
            :disabled="disabled"
            :label="placeholder"
            color="red accent-4"
            :hide-details="details"
            :rules="rules || []"
            :false-value="falseVal"
            :true-value="trueVal"
        >
            <template v-slot:label >
                <span class="label">
                    <slot></slot>                
                </span>
            </template>
        </v-checkbox>
    </div>
</template>

<script>
export default {

    name: 'UiCheckbox', 

    props:{
        details:{
            default: false
        },

        falseVal:{
            default: false
        },

        trueVal:{
            default: true
        },

        error:{
            type: Boolean,
            default: false
        },

        value: {
            required: true
        },

        rules:{
            default: () => [],
            required: false
        },

        placeholder: {
            type: String,
            required: false
        },

        disabled:{
            type: Boolean,
            default: false
        },
    },

    methods:{
        change(event){
            this.$emit('change', event)
            this.$emit('input', event)
        }
    }

}
</script>

<style>
    .check-main-wrapper{
        display: flex;
    }
    .check-box{
       margin-top: 0 !important;
       padding-top: 0 !important;
    }
    .check-box .v-label{
        margin-bottom: 0 !important;
        font-family: 'Helvetica';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        color: #000000;
    }
    @media (max-width: 850px) {
        .label{
            font-size: 24px;
        }
    }
    @media (min-width: 850px) {
        .label{
            font-size: 24px;
        }
    }
    @media (max-width: 1650px) {
        .label{
            font-size: 20px;
        }
    }
    @media (max-width: 1350px) {
        .label{
            font-size: 14px;
        }
    }
    @media (max-width: 850px) {
        .label{
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// UiCheckbox.vue?6bdbdf95